import zenscroll from 'zenscroll';

const time = 500;
const spaceToElement = 50;

zenscroll.setup(time, spaceToElement)